import { render, staticRenderFns } from "./create_org_form.vue?vue&type=template&id=5e67a79f&scoped=true&"
import script from "./create_org_form.vue?vue&type=script&lang=js&"
export * from "./create_org_form.vue?vue&type=script&lang=js&"
import style0 from "./create_org_form.vue?vue&type=style&index=0&id=5e67a79f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67a79f",
  null
  
)

export default component.exports